<div class="modal-header">
	<h2 class="modal-title" translate="GenerationStatementModal.Title"></h2>
	<button aria-label="Bouton Fermer Modal" type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
</div>

<div class="modal-body">
	<form [formGroup]="form">
		<div class="row">
			<date-picker-range
				[fromDateControl]="form?.controls?.fromDate"
				[toDateControl]="form?.controls?.toDate"
				[fromDateLabel]="'Labels.DateDebutGenerationReleve'"
				[toDateLabel]="'Labels.DateFinGenerationReleve'"
				[classCol]="'col-md-6'"
			></date-picker-range>
		</div>
		<div class="row">
			<div class="col-md-6">
				<label class="custom-checkbox">
					<input type="checkbox" formControlName="hasLogo" />
					<span class="label-text" translate="Labels.HasLogoGenerationReleve"></span>
				</label>
			</div>
		</div>
	</form>
</div>

<div class="modal-footer">
	<button aria-label="Bouton Fermer Modal" type="button" class="btn btn-secondary" (click)="onClose()">
		<i class="far fa-times"></i>
		{{ 'Actions.Cancel' | translate }}
	</button>
	<button aria-label="Bouton Générer Relevé" type="button" class="btn btn-primary" (click)="onConfirm()">
		<i class="far fa-check"></i>
		{{ 'Actions.Confirm' | translate }}
	</button>
</div>
